import { render, staticRenderFns } from "./WorstAddressesWidget.vue?vue&type=template&id=7917b4e8&scoped=true&"
import script from "./WorstAddressesWidget.vue?vue&type=script&lang=js&"
export * from "./WorstAddressesWidget.vue?vue&type=script&lang=js&"
import style0 from "./WorstAddressesWidget.vue?vue&type=style&index=0&id=7917b4e8&lang=scss&scoped=true&"
import style1 from "./WorstAddressesWidget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7917b4e8",
  null
  
)

export default component.exports